module.exports = __webpack_public_path__ + "img/image26.3b429e34.png";